/**
 *  Copyright (C) 2022 - Jeci SARL - https://jeci.fr
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU Affero General Public License as
 *  published by the Free Software Foundation, either version 3 of the
 *  License, or (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU Affero General Public License for more details.
 *
 *  You should have received a copy of the GNU Affero General Public License
 *  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */

/**
 * Mapping of common Alfresco property aliases to their Solr/model field names.
 * Shared between AftsQueryBuilder and GhostMatcher.
 */
export const ALIAS_MAP = {
  modifiedat: "cm:modified",
  createdat: "cm:created",
  createdbyuser: "cm:creator",
  modifiedbyuser: "cm:modifier",
  name: "cm:name",
  title: "cm:title",
  description: "cm:description",
  mimetype: "cm:content.mimetype",
  encoding: "cm:content.encoding",
  sizeinbytes: "cm:content.size",
  type: "TYPE",
};

/**
 * Resolves a property alias to its full field name.
 * @param {string} prop - The property name or alias.
 * @returns {string} The resolved field name.
 */
export function resolveAlias(prop) {
  if (!prop) {
    return prop;
  }
  return ALIAS_MAP[prop.toLowerCase()] || prop;
}
